import unescapedText from 'I18n/utils/unescapedText';
import { ProductType } from 'marketplace-ui-common/types/products';
import { AgentType } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';

export function translateProductType(type: ProductType, agentType?: AgentType) {
  switch (type) {
    case 'AGENT':
      return agentType === 'ASSISTANT'
        ? unescapedText('trellisEcosystem.productType.ASSISTANT')
        : unescapedText('trellisEcosystem.productType.AGENT');
    case 'APP':
      return unescapedText('trellisEcosystem.productType.APP');
    case 'MODULE':
      return unescapedText('trellisEcosystem.productType.MODULE');
    case 'THEME':
      return unescapedText('trellisEcosystem.productType.THEME');
    default:
      // Log error for unknown product type
      console.error(`Unknown product type encountered: ${type}`);
      return type;
  }
}
